import { PrescriptionPackageDocumentQuery } from '@dreryk/egabinet-prescription-frontend-api';

import { performCqrsQueryGet } from '@dreryk/command-query-react-common';

import { printDocumentAsPdf } from '~libs.typescript';

export const printPrescriptionPackage = async (prescriptionPackageId: number): Promise<void> => {
   const result = await performCqrsQueryGet<{ data: string }>(() => {
      const query = new PrescriptionPackageDocumentQuery();
      query.prescriptionPackageId = prescriptionPackageId;
      return query;
   });

   await printDocumentAsPdf({
      htmlBase64: result.data,
   });
};
